<div class="checkout-area">
  @if (settings.terms.enabled) {
    <label class="checkout-area__terms" [style.color]="settings.terms.textColor || null">
      <input type="checkbox" disabled class="checkout-area__terms-checkbox" />
      <span [innerHTML]="settings.terms.text"></span>
    </label>
  }

  @if (settings.checkoutButton.enabled) {
    <button
      type="button"
      class="checkout-area__primary"
      [class.checkout-area__primary--disabled-look]="checkoutDisabledLook"
      [style.color]="resolvedCheckout.textColor"
      [style.background-color]="resolvedCheckout.backgroundColor"
      [style.border-radius.px]="resolvedCheckout.cornerRadius"
      (mouseenter)="onPrimaryHoverEnter($event)"
      (mouseleave)="onPrimaryHoverLeave($event)">
      {{ settings.checkoutButton.label }}
    </button>
  }

  @if (settings.viewCartButton.enabled) {
    <button
      type="button"
      class="checkout-area__view-cart"
      [style.color]="resolvedViewCart.textColor"
      [style.background-color]="resolvedViewCart.backgroundColor"
      [style.border-radius.px]="resolvedViewCart.cornerRadius"
      (mouseenter)="onViewCartHoverEnter($event)"
      (mouseleave)="onViewCartHoverLeave($event)">
      {{ settings.viewCartButton.label }}
    </button>
  }

  @if (settings.continueShoppingButton.enabled) {
    <button type="button" class="checkout-area__continue">
      {{ settings.continueShoppingButton.label }}
    </button>
  }
</div>
